/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MCPToolFilter,
  MCPToolFilter$inboundSchema,
  MCPToolFilter$Outbound,
  MCPToolFilter$outboundSchema,
} from "./mcptoolfilter.js";

export type MCPToolApprovalFilter = {
  always?: MCPToolFilter | undefined;
  never?: MCPToolFilter | undefined;
};

/** @internal */
export const MCPToolApprovalFilter$inboundSchema: z.ZodType<
  MCPToolApprovalFilter,
  z.ZodTypeDef,
  unknown
> = z.object({
  always: MCPToolFilter$inboundSchema.optional(),
  never: MCPToolFilter$inboundSchema.optional(),
});
/** @internal */
export type MCPToolApprovalFilter$Outbound = {
  always?: MCPToolFilter$Outbound | undefined;
  never?: MCPToolFilter$Outbound | undefined;
};

/** @internal */
export const MCPToolApprovalFilter$outboundSchema: z.ZodType<
  MCPToolApprovalFilter$Outbound,
  z.ZodTypeDef,
  MCPToolApprovalFilter
> = z.object({
  always: MCPToolFilter$outboundSchema.optional(),
  never: MCPToolFilter$outboundSchema.optional(),
});

export function mcpToolApprovalFilterToJSON(
  mcpToolApprovalFilter: MCPToolApprovalFilter,
): string {
  return JSON.stringify(
    MCPToolApprovalFilter$outboundSchema.parse(mcpToolApprovalFilter),
  );
}
export function mcpToolApprovalFilterFromJSON(
  jsonString: string,
): SafeParseResult<MCPToolApprovalFilter, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MCPToolApprovalFilter$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MCPToolApprovalFilter' from JSON`,
  );
}
